import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Projecto73xqbcrzskm as Project,
  Clientuccelyr89ch8 as Client,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_client1ubw0usktkrr9 as get_client } from '../../../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../components/nav/crowpay.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../dialogs/GenericDialog.mjs';
import {
  WarningButtonSemantice48d7oqt0xse as WarningButtonSemantic,
  get_deleteButton1v46c8rhktdg5 as get_deleteButton,
  specCenteredContent3evlhhbrk2e00 as specCenteredContent,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
} from '../../theming/buttons.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { modify2eca96i8s7hc2 as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../utils/Draft.ext.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atStart2tgdnaxgj04ln as get_atStart,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  timesx4ey3un7ihw1 as times,
  Dimensions32ju1l7z4mh as Dimension,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_trash3qsdn4kaynjmu as get_trash,
  get_edit2tiiawv2658bs as get_edit,
} from '../../../icons.mjs';
import { get_rem14pbkv8p42gid as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  resize3py5p2yrjp6p7 as resize,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
} from '../../../utils/utils.mjs';
import {
  icon1sxjaie5w1apt as icon,
  errorTextv58wi1t0me7u as errorText,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  title1nssp3ryhwuqj as title,
} from '../../theming/Titles.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Draftazcheef5x425 as Draft,
  Draftj5auffrm1u2b as Draft_0,
} from '../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { nullToBlank26aqgq3jx9stc as nullToBlank } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import {
  get_userFirstName2cra61zxj7d12 as get_userFirstName,
  get_userLastName33o3zvsnv683s as get_userLastName,
  get_email2n3fpv03ue5oj as get_email,
  get_phoneNumber3gk472wmm72lr as get_phoneNumber,
  get_address2if6gui37gjdo as get_address,
  get_contractor1cpbosmtltvri as get_contractor,
  get_name220tirn7t92ql as get_name,
} from '../../../../../../crowpay-shared/com/crowpay/ClientFields.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { assertNotBlank3rcqh0n27fq5q as assertNotBlank } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import {
  validategsg6go7eyi9d as validate,
  assertValidEmail3vrj63qp73iex as assertValidEmail,
  assertValidPhoneNumber18rbry4lwjr66 as assertValidPhoneNumber,
} from '../../../utils/validation.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import {
  PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput,
  PhoneNumberFormat_USA_getInstance22618h2la6wkm as PhoneNumberFormat_USA_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { addressForm32k03uh8crpev as addressForm } from '../../components/addressForm.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import {
  get_notNullContractorsjk9enub7uol as get_notNullContractor,
  get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor,
} from '../../../selectedContractor.mjs';
import { Addresscpovxna1tjmg as Address } from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ReactiveMutableSet2bktc9g3zyrtk as ReactiveMutableSet } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableSet.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { TargetCategory1szv6uyg7o310 as TargetCategory } from '../../../utils/JumpTo.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { get_outlinedfhcs63de0vzu as get_outlined } from '../../theming/appTheme.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { keyString2ezqnhf3jck9c as keyString } from '../../components/keyValue.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { isDigit3mimrri4wkzop as isDigit } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { takeLast2r8kr8e6g6hi7 as takeLast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { render38qn7o0b2bza2 as render } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Routes.mjs';
import { children3sl29z5no2wyp as children } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.ext.mjs';
import {
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render_0,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from './IsContractorScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = tmp.kfv_1.geo($this.njf_1.b5c_1).kem($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = await_0($this.sjf_1.qjf_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var c = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.rfv_1;
  // Inline function 'com.lightningkite.lightningdb.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$2);
  var tmp$ret$4 = eq(get_client(it), c.b5c_1);
  var tmp$ret$5 = new (Query())(tmp$ret$4, orderBy, 0, 1);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = tmp_1.heo(tmp$ret$5);
  var tmp_3 = await_0(this_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var projects = tmp_3;
  if (projects.i1()) {
    var tmp_4 = get_dialogStack();
    var tmp_5 = WarningButtonSemantic();
    tmp_4.zgd(new (GenericConfirmationDialog())('Delete Client?', 'Deleting a client cannot be undone. Are you sure you want to delete this client?', VOID, 'Delete Client', VOID, tmp_5, VOID, VOID, VOID, VOID, ClientForm$render$slambda$slambda_0(c)));
  } else {
    get_dialogStack().zgd(GenericDialog().bgz('This client is a part of existing projects and cannot be deleted.'));
  }
  return Unit_instance;
}
var ClientForm$render$slambda$slambdaClass;
function ClientForm$render$slambda$slambda() {
  if (ClientForm$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor($c) {
        this.njf_1 = $c;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ClientForm$render$slambda$slambdaClass = $;
  }
  return ClientForm$render$slambda$slambdaClass;
}
function ClientForm$render$slambda$slambda_0($c) {
  var i = new (ClientForm$render$slambda$slambda())($c);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  $this.tjf_1.qjf_1.nai();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.tjf_1.qjf_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.tjf_1.ojf_1(tmp$ret$0, false, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ujf_1.rjf_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  return it.k5c(VOID, VOID, tmp0_elvis_lhs == null ? it.p92() : tmp0_elvis_lhs);
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_issues($this.vjf_1.qjf_1);
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!tmp.i1()) {
    $this.vjf_1.pjf_1.oam(true);
    return Unit_instance;
  } else {
    $this.vjf_1.pjf_1.oam(false);
  }
  var tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.vjf_1.rjf_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'kotlin.text.isNullOrBlank' call
  var this_2 = tmp_1;
  if (this_2 == null || isBlank(this_2)) {
    // Inline function 'kotlin.let' call
    var it = $this.vjf_1.qjf_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var tmp_2 = await_0(it, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp_3 = tmp_2.p92();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = it.aak();
    var tmp_4 = await_0(this_3, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp_0 = !(tmp_3 === tmp_4.p92());
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp_5 = modify($this.vjf_1.qjf_1, ClientForm$render$slambda$slambda_2(), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = $this.vjf_1.rjf_1.cak();
    var tmp_6 = await_0(this_4, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    if (tmp_6) {
      var tmp_7 = modify($this.vjf_1.qjf_1, ClientForm$render$slambda$slambda_4($this.vjf_1), $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
    }
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_5 = get_session();
  var tmp_8 = await_0(this_5, $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  var tmp$ret$9 = tmp_8;
  var tmp_9 = pushChanges($this.vjf_1.qjf_1, tmp$ret$9.kfv_1, $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  var updated = tmp_9;
  var tmp_10 = $this.vjf_1.ojf_1(updated, true, $completion);
  if (tmp_10 === get_COROUTINE_SUSPENDED())
    tmp_10 = yield tmp_10;
  return Unit_instance;
}
var ClientForm$render$slambda$slambdaClass_0;
function ClientForm$render$slambda$slambda_1() {
  if (ClientForm$render$slambda$slambdaClass_0 === VOID) {
    class $ {
      wjf(it, $completion) {
        return it.k5c(VOID, VOID, it.p92());
      }
      s2(p1, $completion) {
        return this.wjf(p1 instanceof Client() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ClientForm$render$slambda$slambdaClass_0 = $;
  }
  return ClientForm$render$slambda$slambdaClass_0;
}
function ClientForm$render$slambda$slambda_2() {
  var i = new (ClientForm$render$slambda$slambda_1())();
  var l = (it, $completion) => i.wjf(it, $completion);
  l.$arity = 1;
  return l;
}
var ClientForm$render$slambda$slambdaClass_1;
function ClientForm$render$slambda$slambda_3() {
  if (ClientForm$render$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.ujf_1 = this$0;
      }
      wjf(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.wjf(p1 instanceof Client() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ClientForm$render$slambda$slambdaClass_1 = $;
  }
  return ClientForm$render$slambda$slambdaClass_1;
}
function ClientForm$render$slambda$slambda_4(this$0) {
  var i = new (ClientForm$render$slambda$slambda_3())(this$0);
  var l = (it, $completion) => i.wjf(it, $completion);
  l.$arity = 1;
  return l;
}
var ClientForm$_init_$slambda_knrb5vClass;
function ClientForm$_init_$slambda_knrb5v() {
  if (ClientForm$_init_$slambda_knrb5vClass === VOID) {
    class $ {
      xjf(_unused_var__etf5q3, _unused_var__etf5q3_0, $completion) {
        return Unit_instance;
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof Client() ? p1 : THROW_CCE();
        return this.xjf(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ClientForm$_init_$slambda_knrb5vClass = $;
  }
  return ClientForm$_init_$slambda_knrb5vClass;
}
function ClientForm$_init_$slambda_knrb5v_0() {
  var i = new (ClientForm$_init_$slambda_knrb5v())();
  var l = (_unused_var__etf5q3, _unused_var__etf5q3_0, $completion) => i.xjf(_unused_var__etf5q3, _unused_var__etf5q3_0, $completion);
  l.$arity = 2;
  return l;
}
function TextInput$_get_hint_$ref_uvwrja(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.placeholder;
    var tmp0_elvis_lhs = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextInput$_set_hint_$ref_i30g2i(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    p0.vb5_1.bb4_1.kb7_1.placeholder = _this__u8e3s4;
    return Unit_instance;
  };
}
function ClientForm$render$lambda($this$specCenteredContent) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$specCenteredContent.pc());
  var tmp0_elvis_lhs = $this$specCenteredContent.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$specCenteredContent : tmp0_elvis_lhs;
  $this$specCenteredContent.gbb(p, view);
  view.zbm(false);
  view.lbb(get_centered(view), icon(view, resize(get_trash(Companion_getInstance()), get_rem(0.8)), 'delete'));
  view.lbb(get_centered(view), body(view, 'Delete'));
  $this$specCenteredContent.hbb(p, view);
  return view;
}
var ClientForm$render$slambdaClass;
function ClientForm$render$slambda() {
  if (ClientForm$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.sjf_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ClientForm$render$slambdaClass = $;
  }
  return ClientForm$render$slambdaClass;
}
function ClientForm$render$slambda_0(this$0) {
  var i = new (ClientForm$render$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ClientForm$render$slambdaClass_0;
function ClientForm$render$slambda_1() {
  if (ClientForm$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.tjf_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ClientForm$render$slambdaClass_0 = $;
  }
  return ClientForm$render$slambdaClass_0;
}
function ClientForm$render$slambda_2(this$0) {
  var i = new (ClientForm$render$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ClientForm$render$slambdaClass_1;
function ClientForm$render$slambda_3() {
  if (ClientForm$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.vjf_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ClientForm$render$slambdaClass_1 = $;
  }
  return ClientForm$render$slambdaClass_1;
}
function ClientForm$render$slambda_4(this$0) {
  var i = new (ClientForm$render$slambda_3())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ClientFormClass;
function ClientForm() {
  if (ClientFormClass === VOID) {
    class $ {
      static yjf(client, reportTo, onClose) {
        reportTo = reportTo === VOID ? null : reportTo;
        var tmp;
        if (onClose === VOID) {
          tmp = ClientForm$_init_$slambda_knrb5v_0();
        } else {
          tmp = onClose;
        }
        onClose = tmp;
        var $this = createThis(this);
        $this.ojf_1 = onClose;
        $this.pjf_1 = Signal().hak(false);
        $this.qjf_1 = validated(Draft(client), reportTo);
        var tmp_0 = $this;
        tmp_0.rjf_1 = Draft_0(($this$Draft) => {
          // Inline function 'kotlin.takeUnless' call
          var this_0 = $this$Draft.daj($this.qjf_1);
          var tmp;
          if (!(this_0.d5c_1 === this_0.p92())) {
            tmp = this_0;
          } else {
            tmp = null;
          }
          var tmp0_safe_receiver = tmp;
          return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d5c_1;
        });
        return $this;
      }
      static zjf(client, onClose) {
        return this.yjf(Signal().hak(client), null, onClose);
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(times(view.mba().jb0_1, 1.5));
        // Inline function 'com.crowpay.views.components.field2' call
        var label = 'Client Name (Optional)';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        view_0.bb9(get_AppDimensions().pg2_1);
        bodyBold(view_0, label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp = view_0.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextInput())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        var tmp_0 = KMutableProperty0();
        var tmp_1 = TextInput$_get_hint_$ref_uvwrja(view_1);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('hint', 0, tmp_0, tmp_1, TextInput$_set_hint_$ref_i30g2i(view_1));
        reactiveScope(view_1, ($this$reactiveScope) => {
          // Inline function 'kotlin.text.ifBlank' call
          var this_1 = $this$reactiveScope.daj(this.qjf_1).p92();
          var tmp;
          if (isBlank(this_1)) {
            tmp = 'Client Name';
          } else {
            tmp = this_1;
          }
          var tmp$ret$3 = tmp;
          this_0.set(tmp$ret$3);
          return Unit_instance;
        });
        view_1.zah(view_1.icn_1, nullToBlank(this.rjf_1));
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp, view_1);
        view_0.lbb(view_0.jbb(SubtextSemantic_getInstance()), errorText(view_0));
        view.hbb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_2 = view.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
        view.gbb(p_2, view_2);
        view_2.zbm(true);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'Contact Info';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextView())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.lba(view_3.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_2 = view_3.vb5_1;
        var tmp_3;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_3 = '\xA0';
        } else {
          tmp_3 = content;
        }
        tmp_2.hbu(tmp_3);
        view_2.hbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().jg2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowCollapsingToColumn())(view_2.pc(), listOf(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_4 = view_2.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.gbb(p_4, view_4);
        var tmp_4 = get_expanding(view_4);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_0 = 'First Name';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.gbb(p_5, view_5);
        view_5.zbm(true);
        view_5.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        view_6.zbm(false);
        view_6.bb9(get_AppDimensions().rg2_1);
        view_6.lbb(get_centered(view_6), bodyBold(view_6, label_0));
        view_6.lbb(colored(view_6, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_6, '*'));
        view_5.hbb(p_6, view_6);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_5 = view_5.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_1 = this.qjf_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_6 = serializerOrContextual(createKType(getKClass(Client()), arrayOf([]), false));
        var tmp$ret$25 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$25);
        var tmp$ret$27 = get_userFirstName(it);
        var tmp$ret$28 = lensPath(this_1, tmp$ret$27);
        var firstName = assertNotBlank(tmp$ret$28);
        var tmp_7 = validate(view_5, firstName, ($this$validate) => $this$validate.daj(this.pjf_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextInput())(view_5.pc());
        var tmp0_elvis_lhs_7 = view_5.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
        view_5.gbb(p_7, view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value = 'First Name';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_7.vb5_1.bb4_1.kb7_1.placeholder = value;
        view_7.zah(view_7.icn_1, firstName);
        view_5.hbb(p_7, view_7);
        view_5.lbb(tmp_7, view_7);
        var tmp_8 = get_issues(firstName);
        var tmp$ret$34 = issueText(view_5, tmp_8, VOID, ($this$issueText) => $this$issueText.daj(this.pjf_1));
        view_5.lbb(tmp_5, tmp$ret$34);
        view_4.hbb(p_5, view_5);
        view_4.lbb(tmp_4, view_5);
        var tmp_9 = get_expanding(view_4);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_1 = 'Last Name';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_8 = view_4.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_4 : tmp0_elvis_lhs_8;
        view_4.gbb(p_8, view_8);
        view_8.zbm(true);
        view_8.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (RowOrCol())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.ebb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.gbb(p_9, view_9);
        view_9.zbm(false);
        view_9.bb9(get_AppDimensions().rg2_1);
        view_9.lbb(get_centered(view_9), bodyBold(view_9, label_1));
        view_9.lbb(colored(view_9, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_9, '*'));
        view_8.hbb(p_9, view_9);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_10 = view_8.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_2 = this.qjf_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_11 = serializerOrContextual(createKType(getKClass(Client()), arrayOf([]), false));
        var tmp$ret$45 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$45);
        var tmp$ret$47 = get_userLastName(it_0);
        var tmp$ret$48 = lensPath(this_2, tmp$ret$47);
        var lastName = assertNotBlank(tmp$ret$48);
        var tmp_12 = validate(view_8, lastName, ($this$validate) => $this$validate.daj(this.pjf_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (TextInput())(view_8.pc());
        var tmp0_elvis_lhs_10 = view_8.ebb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
        view_8.gbb(p_10, view_10);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_0 = 'Last Name';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_10.vb5_1.bb4_1.kb7_1.placeholder = value_0;
        view_10.zah(view_10.icn_1, lastName);
        view_8.hbb(p_10, view_10);
        view_8.lbb(tmp_12, view_10);
        var tmp_13 = get_issues(lastName);
        var tmp$ret$54 = issueText(view_8, tmp_13, VOID, ($this$issueText) => $this$issueText.daj(this.pjf_1));
        view_8.lbb(tmp_10, tmp$ret$54);
        view_4.hbb(p_8, view_8);
        view_4.lbb(tmp_9, view_8);
        view_2.hbb(p_4, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint_0 = get_AppDimensions().ig2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (RowCollapsingToColumn())(view_2.pc(), listOf(new (Dimension())(breakpoint_0)));
        var tmp0_elvis_lhs_11 = view_2.ebb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_2 : tmp0_elvis_lhs_11;
        view_2.gbb(p_11, view_11);
        var tmp_14 = get_expanding(view_11);
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (RowOrCol())(view_11.pc());
        var tmp0_elvis_lhs_12 = view_11.ebb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
        view_11.gbb(p_12, view_12);
        view_12.zbm(true);
        view_12.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (RowOrCol())(view_12.pc());
        var tmp0_elvis_lhs_13 = view_12.ebb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
        view_12.gbb(p_13, view_13);
        view_13.zbm(false);
        view_13.bb9(get_AppDimensions().rg2_1);
        view_13.lbb(get_centered(view_13), bodyBold(view_13, 'Email'));
        view_13.lbb(colored(view_13, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_13, '*'));
        view_12.hbb(p_13, view_13);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_15 = view_12.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_3 = this.qjf_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_16 = serializerOrContextual(createKType(getKClass(Client()), arrayOf([]), false));
        var tmp$ret$68 = isInterface(tmp_16, KSerializer()) ? tmp_16 : THROW_CCE();
        var it_1 = new (DataClassPathSelf())(tmp$ret$68);
        var tmp$ret$70 = get_email(it_1);
        var tmp$ret$71 = lensPath(this_3, tmp$ret$70);
        var email = assertValidEmail(tmp$ret$71);
        var tmp_17 = validate(view_12, email, ($this$validate) => $this$validate.daj(this.pjf_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (TextInput())(view_12.pc());
        var tmp0_elvis_lhs_14 = view_12.ebb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_12 : tmp0_elvis_lhs_14;
        view_12.gbb(p_14, view_14);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_14.vb5_1.bb4_1.kb7_1.placeholder = 'Email';
        view_14.zah(view_14.icn_1, email);
        view_12.hbb(p_14, view_14);
        view_12.lbb(tmp_17, view_14);
        var tmp_18 = get_issues(email);
        var tmp$ret$77 = issueText(view_12, tmp_18, VOID, ($this$issueText) => $this$issueText.daj(this.pjf_1));
        view_12.lbb(tmp_15, tmp$ret$77);
        view_11.hbb(p_12, view_12);
        view_11.lbb(tmp_14, view_12);
        var tmp_19 = get_expanding(view_11);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_2 = 'Phone Number';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (RowOrCol())(view_11.pc());
        var tmp0_elvis_lhs_15 = view_11.ebb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_11 : tmp0_elvis_lhs_15;
        view_11.gbb(p_15, view_15);
        view_15.zbm(true);
        view_15.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (RowOrCol())(view_15.pc());
        var tmp0_elvis_lhs_16 = view_15.ebb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_15 : tmp0_elvis_lhs_16;
        view_15.gbb(p_16, view_16);
        view_16.zbm(false);
        view_16.bb9(get_AppDimensions().rg2_1);
        view_16.lbb(get_centered(view_16), bodyBold(view_16, label_2));
        view_16.lbb(colored(view_16, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_16, '*'));
        view_15.hbb(p_16, view_16);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_20 = view_15.jbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_4 = this.qjf_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_21 = serializerOrContextual(createKType(getKClass(Client()), arrayOf([]), false));
        var tmp$ret$88 = isInterface(tmp_21, KSerializer()) ? tmp_21 : THROW_CCE();
        var it_2 = new (DataClassPathSelf())(tmp$ret$88);
        var tmp$ret$90 = get_phoneNumber(it_2);
        var tmp$ret$91 = lensPath(this_4, tmp$ret$90);
        var phone = assertValidPhoneNumber(tmp$ret$91);
        var tmp_22 = validate(view_15, phone, ($this$validate) => $this$validate.daj(this.pjf_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
        // Inline function 'kotlin.apply' call
        var this_5 = new (PhoneNumberInput())(view_15);
        this_5.vcl('Phone Number');
        view_15.zah(this_5.c2a(), phone);
        view_15.lbb(tmp_22, this_5);
        var tmp_23 = get_issues(phone);
        var tmp$ret$95 = issueText(view_15, tmp_23, VOID, ($this$issueText) => $this$issueText.daj(this.pjf_1));
        view_15.lbb(tmp_20, tmp$ret$95);
        view_11.hbb(p_15, view_15);
        view_11.lbb(tmp_19, view_15);
        view_2.hbb(p_11, view_11);
        view.hbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_17 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_17 = view.ebb_1;
        var p_17 = tmp0_elvis_lhs_17 == null ? view : tmp0_elvis_lhs_17;
        view.gbb(p_17, view_17);
        view_17.zbm(true);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_18 = new (TextView())(view_17.pc());
        var tmp0_elvis_lhs_18 = view_17.ebb_1;
        var p_18 = tmp0_elvis_lhs_18 == null ? view_17 : tmp0_elvis_lhs_18;
        view_17.gbb(p_18, view_18);
        view_18.lba(view_18.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_24 = view_18.vb5_1;
        var tmp_25;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength('Address') === 0) {
          tmp_25 = '\xA0';
        } else {
          tmp_25 = 'Address';
        }
        tmp_24.hbu(tmp_25);
        view_17.hbb(p_18, view_18);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_6 = this.qjf_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_26 = serializerOrContextual(createKType(getKClass(Client()), arrayOf([]), false));
        var tmp$ret$114 = isInterface(tmp_26, KSerializer()) ? tmp_26 : THROW_CCE();
        var it_3 = new (DataClassPathSelf())(tmp$ret$114);
        var tmp$ret$116 = get_address(it_3);
        var tmp_27 = lensPath(this_6, tmp$ret$116);
        addressForm(view_17, tmp_27, VOID, VOID, VOID, ($this$addressForm) => $this$addressForm.daj(this.pjf_1));
        view.hbb(p_17, view_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_19 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_19 = view.ebb_1;
        var p_19 = tmp0_elvis_lhs_19 == null ? view : tmp0_elvis_lhs_19;
        view.gbb(p_19, view_19);
        view_19.zbm(false);
        view_19.bb9(get_AppDimensions().kg2_1);
        var tmp_28 = get_expanding(view_19);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_20 = new (Space())(view_19.pc());
        var tmp0_elvis_lhs_20 = view_19.ebb_1;
        var p_20 = tmp0_elvis_lhs_20 == null ? view_19 : tmp0_elvis_lhs_20;
        view_19.gbb(p_20, view_20);
        view_19.hbb(p_20, view_20);
        view_19.lbb(tmp_28, view_20);
        var tmp_29 = view_19.kbb(shownWhen(view_19, VOID, ($this$shownWhen) => !($this$shownWhen.daj($this$shownWhen.daj(get_session()).kfv_1.geo($this$shownWhen.daj(this.qjf_1.aak()).b5c_1)) == null)), get_deleteButton(view_19));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_21 = new (Button())(view_19.pc());
        var tmp0_elvis_lhs_21 = view_19.ebb_1;
        var p_21 = tmp0_elvis_lhs_21 == null ? view_19 : tmp0_elvis_lhs_21;
        view_19.gbb(p_21, view_21);
        if (get_viewIsNarrow(view_21)) {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_22 = new (RowOrCol())(view_21.pc());
          var tmp0_elvis_lhs_22 = view_21.ebb_1;
          var p_22 = tmp0_elvis_lhs_22 == null ? view_21 : tmp0_elvis_lhs_22;
          view_21.gbb(p_22, view_22);
          view_22.zbm(false);
          view_22.lbb(get_centered(view_22), icon(view_22, resize(get_trash(Companion_getInstance()), get_rem(0.8)), 'delete'));
          view_22.lbb(get_centered(view_22), body(view_22, 'Delete'));
          view_21.hbb(p_22, view_22);
        } else {
          specCenteredContent(view_21, VOID, ClientForm$render$lambda);
        }
        onClick(view_21, VOID, VOID, ClientForm$render$slambda_0(this));
        view_19.hbb(p_21, view_21);
        view_19.lbb(tmp_29, view_21);
        var tmp_30 = get_secondaryButton(view_19);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_23 = new (Button())(view_19.pc());
        var tmp0_elvis_lhs_23 = view_19.ebb_1;
        var p_23 = tmp0_elvis_lhs_23 == null ? view_19 : tmp0_elvis_lhs_23;
        view_19.gbb(p_23, view_23);
        specCenteredText(view_23, 'Cancel');
        onClick(view_23, VOID, VOID, ClientForm$render$slambda_2(this));
        view_19.hbb(p_23, view_23);
        view_19.lbb(tmp_30, view_23);
        var tmp_31 = get_primaryButton(view_19);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_24 = new (Button())(view_19.pc());
        var tmp0_elvis_lhs_24 = view_19.ebb_1;
        var p_24 = tmp0_elvis_lhs_24 == null ? view_19 : tmp0_elvis_lhs_24;
        view_19.gbb(p_24, view_24);
        specCenteredText(view_24, 'Save');
        onClick(view_24, 'Save', VOID, ClientForm$render$slambda_4(this));
        view_19.hbb(p_24, view_24);
        view_19.lbb(tmp_31, view_24);
        view.hbb(p_19, view_19);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'ClientForm', VOID, VOID, [Page()]);
    ClientFormClass = $;
  }
  return ClientFormClass;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.kfv_1;
  var tmp_1 = await_0(get_notNullContractor(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'kotlin.also' call
  var this_1 = new (Client())(VOID, tmp_1, '', VOID, VOID, '', '', new (Address())());
  $this.hjg_1.gjg_1.bg5(this_1.b5c_1);
  $this.hjg_1.djg_1.nam(this_1.b5c_1);
  var tmp_2 = tmp_0.eek(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.jjg_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  $this.ijg_1.gjg_1.zg4(tmp$ret$0.af_1.b5c_1, $this.kjg_1);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.mjg_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  $this.ljg_1.djg_1.nam(tmp$ret$0.af_1.b5c_1);
  return Unit_instance;
}
function ContractorClients$clients$lambda($this$remember) {
  var c = $this$remember.daj(get_notNullContractor());
  var tmp = $this$remember.daj(get_session()).kfv_1;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Client()), arrayOf([]), false));
  var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$0);
  var tmp_1 = eq(get_contractor(it), c);
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(Client()), arrayOf([]), false));
  var tmp$ret$5 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$5);
  this_0.k4a(get_name(it_0));
  var tmp$ret$10 = this_0.m1r();
  return $this$remember.daj(tmp.heo(new (Query())(tmp_1, tmp$ret$10)));
}
var ContractorClients$clientsToForms$lambda$slambdaClass;
function ContractorClients$clientsToForms$lambda$slambda() {
  if (ContractorClients$clientsToForms$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.njg_1 = this$0;
      }
      xjf(it, _unused_var__etf5q3, $completion) {
        this.njg_1.djg_1.mam(it.b5c_1);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof Client() ? p1 : THROW_CCE();
        return this.xjf(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    ContractorClients$clientsToForms$lambda$slambdaClass = $;
  }
  return ContractorClients$clientsToForms$lambda$slambdaClass;
}
function ContractorClients$clientsToForms$lambda$slambda_0(this$0) {
  var i = new (ContractorClients$clientsToForms$lambda$slambda())(this$0);
  var l = (it, _unused_var__etf5q3, $completion) => i.xjf(it, _unused_var__etf5q3, $completion);
  l.$arity = 2;
  return l;
}
function ContractorClients$renderMainContent$lambda($this$shownDefaultFalse) {
  return !($this$shownDefaultFalse.daj(get_selectedContractor()) == null);
}
var ContractorClients$renderMainContent$slambdaClass;
function ContractorClients$renderMainContent$slambda() {
  if (ContractorClients$renderMainContent$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.hjg_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorClients$renderMainContent$slambdaClass = $;
  }
  return ContractorClients$renderMainContent$slambdaClass;
}
function ContractorClients$renderMainContent$slambda_0(this$0) {
  var i = new (ContractorClients$renderMainContent$slambda())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.yb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function ContractorClients$renderMainContent$lambda_0(it) {
  return it.af_1.b5c_1;
}
var ContractorClients$renderMainContent$lambda$slambdaClass;
function ContractorClients$renderMainContent$lambda$slambda() {
  if (ContractorClients$renderMainContent$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $clientAndForm, $$this$card) {
        this.ijg_1 = this$0;
        this.jjg_1 = $clientAndForm;
        this.kjg_1 = $$this$card;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    ContractorClients$renderMainContent$lambda$slambdaClass = $;
  }
  return ContractorClients$renderMainContent$lambda$slambdaClass;
}
function ContractorClients$renderMainContent$lambda$slambda_0(this$0, $clientAndForm, $$this$card) {
  var i = new (ContractorClients$renderMainContent$lambda$slambda())(this$0, $clientAndForm, $$this$card);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ContractorClients$renderMainContent$lambda$slambdaClass_0;
function ContractorClients$renderMainContent$lambda$slambda_1() {
  if (ContractorClients$renderMainContent$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $clientAndForm) {
        this.ljg_1 = this$0;
        this.mjg_1 = $clientAndForm;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ContractorClients$renderMainContent$lambda$slambdaClass_0 = $;
  }
  return ContractorClients$renderMainContent$lambda$slambdaClass_0;
}
function ContractorClients$renderMainContent$lambda$slambda_2(this$0, $clientAndForm) {
  var i = new (ContractorClients$renderMainContent$lambda$slambda_1())(this$0, $clientAndForm);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ContractorClientsClass;
function ContractorClients() {
  if (ContractorClientsClass === VOID) {
    class $ {
      constructor() {
        this.ajg_1 = new (Constant())(_Constant___init__impl__v45mub('Clients'));
        this.bjg_1 = MemberRole_Manager_getInstance();
        var tmp = this;
        tmp.cjg_1 = remember(VOID, VOID, VOID, ContractorClients$clients$lambda);
        this.djg_1 = ReactiveMutableSet().bao();
        this.ejg_1 = HashMap().n8();
        var tmp_0 = this;
        tmp_0.fjg_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var clients = $this$remember.daj(this.cjg_1);
          var editing = $this$remember.daj(this.djg_1);
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(clients, 10));
          var _iterator__ex2g4s = clients.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp;
            if (editing.t1(item.b5c_1)) {
              var tmp0 = this.ejg_1;
              // Inline function 'kotlin.collections.getOrPut' call
              var key = item.b5c_1;
              var value = tmp0.p3(key);
              var tmp_0;
              if (value == null) {
                var answer = ClientForm().zjf(item, ContractorClients$clientsToForms$lambda$slambda_0(this));
                tmp0.s3(key, answer);
                tmp_0 = answer;
              } else {
                tmp_0 = value;
              }
              tmp = tmp_0;
            } else {
              tmp = null;
            }
            var form = tmp;
            var tmp$ret$2 = to(item, form);
            destination.v(tmp$ret$2);
          }
          return destination;
        });
        this.gjg_1 = new (TargetCategory())('Client');
      }
      wcv() {
        return this.ajg_1;
      }
      dhg() {
        return this.bjg_1;
      }
      thi(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        view.bb9(get_AppDimensions().bg2_1);
        title(view, 'Clients');
        var tmp = view.kbb(get_atStart(view), get_primaryButton(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Button())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        shownDefaultFalse(view_0, ContractorClients$renderMainContent$lambda);
        specCenteredText(view_0, '+ Client');
        onClick(view_0, VOID, VOID, ContractorClients$renderMainContent$slambda_0(this));
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        var tmp_0 = get_centered(view);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        view_1.lba(view_1.qb6_1.abf(SubtitleSemantic_getInstance()));
        var tmp_1 = KMutableProperty0();
        var tmp_2 = TextView$_get_shown_$ref_kipsub(view_1);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('shown', 0, tmp_1, tmp_2, TextView$_set_shown_$ref_l7jsq9(view_1));
        reactiveScope(view_1, ($this$reactiveScope) => {
          var tmp$ret$3 = $this$reactiveScope.daj(this.cjg_1).i1();
          this_0.set(tmp$ret$3);
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var value = 'You have no Clients yet. Create a new Client.';
        var tmp_3 = view_1.vb5_1;
        var tmp_4;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(value) === 0) {
          tmp_4 = '\xA0';
        } else {
          tmp_4 = value;
        }
        tmp_3.hbu(tmp_4);
        view.hbb(p_1, view_1);
        view.lbb(tmp_0, view_1);
        var tmp_5 = get_expanding(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
        // Inline function 'kotlin.apply' call
        var this_1 = new (Recycler2())(view, true);
        var tmp_6 = ContractorClients$renderMainContent$lambda_0;
        children(this_1, this.fjg_1, tmp_6, ($this$children, clientAndForm) => {
          var tmp = $this$children.kbb(sizeConstraints($this$children, VOID, get_AppDimensions().gg2_1), get_outlined($this$children));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$children.pc());
          var tmp0_elvis_lhs = $this$children.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$children : tmp0_elvis_lhs;
          $this$children.gbb(p, view);
          view.zbm(true);
          launch(view, VOID, VOID, ContractorClients$renderMainContent$lambda$slambda_0(this, clientAndForm, view));
          var tmp_0 = shownWhen(view, VOID, ($this$shownWhen) => !$this$shownWhen.daj(this.djg_1).t1($this$shownWhen.daj(clientAndForm).af_1.b5c_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(false);
          var tmp_1 = get_expanding(view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view_0.pc());
          var tmp0_elvis_lhs_1 = view_0.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
          view_0.gbb(p_1, view_1);
          view_1.zbm(true);
          keyString(view_1, 'Client Name', ($this$keyString) => $this$keyString.daj(clientAndForm).af_1.d5c_1);
          keyString(view_1, 'Email', ($this$keyString) => $this$keyString.daj(clientAndForm).af_1.g5c_1);
          keyString(view_1, 'Phone', ($this$keyString) => {
            var tmp = PhoneNumberFormat_USA_getInstance();
            // Inline function 'kotlin.text.filter' call
            var tmp0 = $this$keyString.daj(clientAndForm).af_1.h5c_1;
            // Inline function 'kotlin.text.filterTo' call
            var destination = StringBuilder().d1();
            var inductionVariable = 0;
            var last = charSequenceLength(tmp0);
            if (inductionVariable < last)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var element = charSequenceGet(tmp0, index);
                if (isDigit(element)) {
                  destination.xb(element);
                }
              }
               while (inductionVariable < last);
            var tmp$ret$14 = destination.toString();
            return tmp.adb(takeLast(tmp$ret$14, 10));
          });
          keyString(view_1, 'Address', ($this$keyString) => $this$keyString.daj(clientAndForm).af_1.i5c_1.toString());
          view_0.hbb(p_1, view_1);
          view_0.lbb(tmp_1, view_1);
          var tmp_2 = view_0.kbb(align(view_0, Align_End_getInstance(), Align_End_getInstance()), get_tertiaryButton(view_0));
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Button())(view_0.pc());
          var tmp0_elvis_lhs_2 = view_0.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
          view_0.gbb(p_2, view_2);
          icon(view_2, resize(get_edit(Companion_getInstance()), get_rem(1.5)), 'Edit Client');
          onClick(view_2, VOID, VOID, ContractorClients$renderMainContent$lambda$slambda_2(this, clientAndForm));
          view_0.hbb(p_2, view_2);
          view_0.lbb(tmp_2, view_2);
          view.hbb(p_0, view_0);
          view.lbb(tmp_0, view_0);
          var tmp_3 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.djg_1).t1($this$shownWhen.daj(clientAndForm).af_1.b5c_1));
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (Frame())(view.pc());
          var tmp0_elvis_lhs_3 = view.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
          view.gbb(p_3, view_3);
          var $this$frame = view_3;
          reactive($this$frame, ($this$reactive) => {
            $this$frame.bba();
            var tmp0_safe_receiver = $this$reactive.daj(clientAndForm).bf_1;
            return tmp0_safe_receiver == null ? null : render(tmp0_safe_receiver, $this$frame);
          });
          view.hbb(p_3, view_3);
          view.lbb(tmp_3, view_3);
          $this$children.hbb(p, view);
          return $this$children.lbb(tmp, view);
        });
        view.lbb(tmp_5, this_1);
        _this__u8e3s4.hbb(p, view);
      }
    }
    protoOf($).fhg = get_awaitingApprovalMessage;
    protoOf($).ghg = renderFinishRegistration;
    protoOf($).hhg = renderAwaitingApproval;
    protoOf($).wd6 = render_0;
    initMetadataForClass($, 'ContractorClients', ContractorClients, VOID, [ContractorPage()]);
    ContractorClientsClass = $;
  }
  return ContractorClientsClass;
}
//region block: exports
export {
  ClientForm as ClientForm3gac2gni7o6s9,
  ContractorClients as ContractorClientsflh7jhpyocdp,
};
//endregion

//# sourceMappingURL=ContractorClients.mjs.map
